import { all } from 'redux-saga/effects';

import auth from './auth/sagas';
import sites from './sites/sagas';

export default function* rootSaga(): Generator {
  return yield all([auth, sites]);
}
